import {
    IMPORT_RATEQUOTE_LIST,
    IMPORT_RATEQUOTE_PAGINATION,
    IMPORT_RATEQUOTE_SUMMARY,
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';
import { callLoader } from '../Loader/actions';
import { ca } from 'date-fns/locale';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getImportRateQuoteList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/RateQuoteImport/GetImportRateQuoteList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: IMPORT_RATEQUOTE_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: IMPORT_RATEQUOTE_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: IMPORT_RATEQUOTE_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
        }
    };
};

export const getCancelledImportRateQuoteList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/RateQuoteImport/GetCancelledImportRateQuoteList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: IMPORT_RATEQUOTE_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: IMPORT_RATEQUOTE_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: IMPORT_RATEQUOTE_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
        }
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getImportRateQuoteByID = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const url = `v1/RateQuoteImport/GetImportRateQuoteByID?ImportRateQuoteId=${payload}`;
            return APICall('get', payload, url).then(result => {
                if (result?.statuscode === 200) {
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const insertRateQuoteImport = (payload) => {
    try {
        const url = `v1/RateQuoteImport/InsertRateQuoteImport`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
                await getImportRateQuoteList(payList);
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateRateQuoteImport = async (payload) => {
    try {
        const url = `v1/RateQuoteImport/UpdateRateQuoteImport`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
                await getImportRateQuoteList(payList);
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const deleteImportRateQuoteList = (payload) => {
    const url = `v1/RateQuoteImport/DeleteImportRateQuoteList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const reinstateImportRateQuoteList = (payload) => {
    const url = `v1/RateQuoteImport/ReinstateImportRateQuoteList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getImportRateQuoteNotes = async (payload) => {
    try {
        const url = `v1/RateQuoteImport/GetImportRateQuoteNotes?ImportRateQuoteId=${payload}`;
        return APICall('get', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const insertImportRateQuoteNotes = async (payload) => {
    try {
        const url = `v1/RateQuoteImport/InsertImportRateQuoteNotes`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return getImportRateQuoteNotes(payload?.RateQuoteId);
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getAddressBookNotes = async (payload) => {
    try {
        const url = `v1/Common/GetAddressBookNotes?addressid=${payload}&type=E`;
        return APICall('get', {}, url).then(async result => {
            if (result?.statuscode === 200) {
                return result?.data || [];
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createBookingRateQuote = async (payload) => {
    try {
        const url = `v1/RateQuote/CreateBooking`;
        return APICall('post', payload, url).then(async result => {
            return result;
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

